import { acceptHMRUpdate, defineStore } from "pinia";

interface User {
  id: number;
  number: string;
  username: string;
  type: string;
  companyName?: string,
  email?: string;
  phone?: string;
  gender: number;
}
export const useUserStore = defineStore("user", () => {
  const userInfo = ref<User>();

  return {
    userInfo
  };
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot));